<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Performance Results</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        <span class="configurationInput">
          <span class="configurationInputLabel">Airflow:</span>
          <input readonly="readonly" [value]="airflow | number:'1.0-0'" class="configurationRatingValueOutput">
          <span class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits(false) }}</span>
        </span>
        <span class="configurationInput">
          <span class="configurationInputLabel">Standard Airflow:</span>
          <input readonly="readonly" [value]="standardAirflow | number:'1.0-0'" class="configurationRatingValueOutput">
          <span class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits(true) }}</span>
        </span>
        <span class="configurationInput">
          <span class="configurationInputLabel">Control Voltage:</span>
          <input readonly="readonly" [value]="highSpeedVoltage" class="configurationRatingValueOutput">
        </span>
      </div>
      <app-performance-results [ratingResponse]="ratingResponse()" [isMetric]="isMetric">
      </app-performance-results>
    </div>
  }
</div>
